<template>
  <BasePageContent>
    <BasePageHeader
      class="px-3"
      sectiontitle="WAREHOUSE DETAIL"
      :title="!Util.isEmpty(Warehouse) ? Warehouse.warehouse_name : ''"
      :description="!Util.isEmpty(Warehouse) ? Warehouse.email : ''"
    >
      <ul class="nk-block-tools g-1">
        <template v-if="!Util.isEmpty(Warehouse)">
          <li class="nk-block-tools-opt">
            <router-link
              :to="{ name: 'warehouse-edit', params: { uuid: Warehouse.uuid } }"
              class="btn w3-theme w3-hover-theme btn-dim btn-outline-light"
            >
              <em class="icon ni ni-edit"></em>
              <span>Edit</span>
            </router-link>
          </li>
          <li>
            <div class="drodown">
              <a
                href="#"
                class="dropdown-toggle btn btn-white btn-dim btn-outline-light"
                data-toggle="dropdown"
              >
                <em class="icon ni ni-more-h"></em
              ></a>
              <div class="dropdown-menu dropdown-menu-right">
                <ul class="link-list-opt no-bdr">
                  <li>
                    <a title="Email Warehouse" href="#">
                      <em class="dd-indc icon ni ni-mail-fill"></em>
                      <span>Email Warehouse</span>
                    </a>
                  </li>
                  <!-- <li>
                    <a title="Create New Invoice" href="#">
                      <em class="dd-indc icon ni ni-file"></em>
                      <span>New Bill</span>
                    </a>
                  </li>
                  <li>
                    <a title="Create New Purchase Order" href="#">
                      <em class="dd-indc icon fas fa-file-alt"></em>
                      <span>New Purchase Order</span>
                    </a>
                  </li> -->
                  <li>
                    <a
                      title="Delete"
                      class="w3-text-red w3-hover-text-black"
                      @click.prevent="DeleteDetail(Warehouse.uuid)"
                      href="#"
                    >
                      <em class="dd-indc icon ni ni-trash"></em>
                      <span> Delete Warehouse</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li class="nk-block-tools-opt">
            <router-link :to="{ name: 'warehouses' }" class="px-2" title="Back">
              <em class="icon ni ni-cross size36"></em>
            </router-link>
          </li>
        </template>
      </ul>
    </BasePageHeader>
    <div class="card-inner card-inner-md">
      <BaseIndicator
        text="Fetching warehouse detail..."
        class="my-4"
        v-if="Util.fetching('getWarehouse')"
        :size="50"
      />
      <template v-else>
        <template v-if="!Util.isEmpty(Warehouse)">
          <div
            class="
              w3-white
              py-0
              px-4
              w3-border-bottom
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <div class="d-flex align-items-center justify-content-between">
              <button
                v-for="view in Views"
                :key="view"
                @click.prevent="SwitchView(view)"
                class="w3-button px-2 pt-3 w3-hover-transparent"
                :class="[
                  ActiveView === view
                    ? 'pb-1 w3-bottombar w3-border-theme'
                    : ' pb-2',
                ]"
              >
                <i
                  class="w3-text-theme w3-hover-text-theme"
                  :class="ViewsIcons[view]"
                />
                <span class="w3-hide-small ml-1">{{ ViewsNames[view] }}</span>
              </button>
            </div>
          </div>
          <div class="p-md-5 p-3">
            <div v-if="IsActiveView('Contact')" class="">
              <div class="p-1">
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Warehouse name
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.warehouse_name ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    First name
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.firstname ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Last name
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.lastname ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Telephone
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.telephone ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Email
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.email ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Website
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.website ?? "-" }}
                  </div>
                </div>
              </div>
              <div class="p-1">
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Internal Note
                  </div>
                  <div
                    class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2"
                    v-html="Util.nl2br(Warehouse.internal_note) ?? '-'"
                  ></div>
                </div>
              </div>
            </div>
            <div v-if="IsActiveView('Address')" class="">
              <div class="p-1">
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Billing Address
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.address ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    City
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.city ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    State
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.state_name ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Zip/Postcode
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.postcode ?? "-" }}
                  </div>
                </div>
                <div class="row w3-border-bottom">
                  <div class="col-sm-4 w3-mobile px-2 pt-2 bold size13">
                    Country
                  </div>
                  <div class="col-sm-8 w3-mobile px-2 pt-md-2 pb-2">
                    {{ Warehouse.country_name ?? "-" }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="IsActiveView('Bills')" class="">
              <div class="row">
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
              </div>
            </div>
            <div v-if="IsActiveView('PurchaseOrders')" class="">
              <div class="row">
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
                <div class="col-md-6">
                  <div class="p-1"></div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="p-5 w3-center">
          <img src="/images/item-not-found.png" class="mb-4" />
          <h4>Warehouse not found</h4>
          <router-link
            :to="{ name: 'warehouses' }"
            class="w3-button w3-white w3-border"
          >
            <span class="">Manage Warehouses</span>
          </router-link>
        </div>
      </template>
    </div>
  </BasePageContent>
</template>

<script>
import { ref, toRef } from "vue";
import { useStore } from "vuex";
// import { useRouter } from "vue-router";
import { Util } from "@/helpers/utilities";
// import WarehouseUpdate from "@/components/ui/warehouse/WarehouseUpdate.vue";
// import Aside from "@/components/ui/Aside.vue";
export default {
  components: {
    // Aside,
    // WarehouseUpdate
  },
  props: {
    warehouse: {
      type: Object,
    },
    uuid: {
      type: String,
    },
  },
  emits: ["oncancel"],
  setup(props) {
    const store = useStore();
    console.log("props.uuid", props.uuid);
    const fetching = ref(true);
    const Warehouse = ref({});
    const WAREHOUSE = toRef(props, "warehouse");
    const GetWarehouse = async () => {
      Warehouse.value = {};
      if (props.uuid) {
        const _warehouse = await store.dispatch(
          "warehouses/getWarehouse",
          props.uuid
        );
        Warehouse.value = {
          ..._warehouse,
        };
      } else if (WAREHOUSE.value) {
        Warehouse.value = WAREHOUSE.value;
      } else {
        Warehouse.value = {};
      }
      fetching.value = false;
    };
    GetWarehouse();
    // TAB VIEWS
    const Views = [
      "Contact",
      "Address",
      // "Bills", "PurchaseOrders"
    ];
    const ActionViews = ["Edit", "Delete"];
    const ViewsIcons = {
      Contact: "fas fa-user-tie",
      Address: "fas fa-map-marker-alt",
      Bills: "fas fa-file-invoice",
      PurchaseOrders: "fas fa-file-alt",
    };
    const ViewsNames = {
      Contact: "Overview",
      Address: "Address",
      Bills: "Bills",
      PurchaseOrders: "Purchase Orders",
    };

    const ActiveView = ref(Views[0]);
    const IsActiveView = (view) => (ActiveView.value === view ? true : false);
    const SwitchView = (view) => {
      const newViewIndex = Views.indexOf(view);
      if (ActiveView.value === Views[newViewIndex]) return false;
      ActiveView.value = Views[newViewIndex];
      return true;
    };

    const DeleteWarehouse = (uuid) => {
      console.log(uuid);
    };
    const OnCancel = () => {
      if (props.uuid) {
        // router.push({
        //   name: "warehouses",
        // });
      } else {
        // emit("oncancel");
      }
    };
    //  END TAB VIEWS

    return {
      store,
      fetching,
      Warehouse,
      OnCancel,
      Views,
      ActionViews,
      ViewsIcons,
      ViewsNames,
      IsActiveView,
      ActiveView,
      SwitchView,
      Util,
      DeleteWarehouse,
    };
  },
};
</script>